import axios from "./AxiosInstance"

const getTypes = () => axios.get(`api/feedbackTypes`)
const create = (data) => axios.post(`api/feedbacks`, { ...data })
export const FeedbackService = {
    getTypes,
    create
}
